import React, { useCallback } from 'react';
import { ReactEditor, useEditor } from 'slate-react';
import { TasquetMarkdownEditor } from '../command';
import { InlineCode, HeadingMark, ListItemCheckbox, PreviewableLink as Link, Image, } from './components/inline';
const ConnectedListItemCheckbox = (props) => {
    const { children, text, checked } = props;
    const editor = useEditor();
    return (React.createElement(ListItemCheckbox, { onClick: useCallback(() => {
            // Waiting 100ms is necessary for slate's onDOMSelectionChange handler to deal with the selection change event,
            // which is debounced by 100ms.
            // See https://github.com/ianstormtaylor/slate/blob/d17a1e86e3ffefc0499806e7d9933640cc1253ed/packages/slate-react/src/components/editable.tsx#L379
            setTimeout(() => TasquetMarkdownEditor.setListItemCheckbox(editor, !checked, ReactEditor.findPath(editor, text)), 100);
        }, [editor, checked, text]) }, children));
};
const MemoizedConnectedListItemCheckbox = React.memo(ConnectedListItemCheckbox);
const renderLeaf = (props) => {
    const { children, leaf, attributes, text } = props;
    let decoratedChildren = children;
    if (leaf.headingMark) {
        decoratedChildren = React.createElement(HeadingMark, null, decoratedChildren);
    }
    if (leaf.emphasis) {
        decoratedChildren = React.createElement("em", null, decoratedChildren);
    }
    if (leaf.strong) {
        decoratedChildren = React.createElement("strong", null, decoratedChildren);
    }
    if (leaf.delete) {
        decoratedChildren = React.createElement("del", null, decoratedChildren);
    }
    if (leaf.inlineCode) {
        decoratedChildren = React.createElement(InlineCode, null, decoratedChildren);
    }
    if (leaf.link) {
        decoratedChildren = (React.createElement(Link, { href: leaf.link.url, title: leaf.link.title }, decoratedChildren));
    }
    if (leaf.listCheckbox) {
        decoratedChildren = (React.createElement(MemoizedConnectedListItemCheckbox, { text: text, checked: leaf.listCheckbox.checked }, decoratedChildren));
    }
    if (leaf.image) {
        decoratedChildren = (React.createElement(Image, { src: leaf.image.url, title: leaf.image.title, alt: leaf.image.alt }, decoratedChildren));
    }
    return React.createElement("span", Object.assign({}, attributes), decoratedChildren);
};
export default renderLeaf;
//# sourceMappingURL=renderLeaf.js.map